import { ConfigContext } from "providers/ConfigHotel";
import { useContext } from "react";

function useConfigHotel() {
  return useContext(ConfigContext);
}

export default useConfigHotel;
